<template>
  <div id="login">
    <div class="card">
    <div class="columns is-gapless">
    <div class="column box is-5">
    <div class="columns is-desktop">
    <div class="column is-8 is-offset-2 hero is-fullheight">
    <section class="hero-body">              
    <div class="page-title-container">
        <h1 class="title is-6 has-text-centered"></h1>

        <h2 v-if="mode == '/login'" class="title is-3 has-text-centered mt-6 mb-6">Login for Metatext</h2>
        <h2 v-else class="title is-3 has-text-centered mt-6 mb-6">Sign up for Metatext</h2>
        
        <h1 v-if="mode == '/login'" class="subtitle is-4 has-text-centered mb-6">
            Login with your work email
        </h1>

        <h1 v-else class="subtitle is-4 has-text-centered mb-6">
            Sign up with your work email
        </h1>
        
        <section id="firebaseui-auth-container"></section>
        <section id="loader">Loading...</section>
        <br><br>
        
        <div class="block">
            By continuing, you are indicating that you accept our 
        <a href="https://metatext.io/doc/terms-of-service" target="_blank">terms & conditions</a>, and our <a href="https://metatext.io/doc/privacy-policy" target="_blank">privacy policy</a>.
        </div>
    </div>
    </section>
    </div>
    </div>
    </div>
    <div class="column">
    <section class="hero is-info is-fullheight">

    <div class="hero-body">
    <div class="">
      <br>
      <p class="subtitle">
          <!-- Messari customer story-->
          "Our shift from manual reviews to an automated classification system with Metatext happened almost overnight – less than a day! The ease maintenance of the AI model have been incredible. It's not just a tool; it's been an AI partner in strengthening our position in the crypto intelligence industry."
      </p>
      <img src="https://messari.io/images/messari-logo-footer-dark-mode.svg"
          class="">
      <p class="subtitle le is-5">
          Messari is the leading provider of crypto market intelligence
      </p>&nbsp;&nbsp;
      <p class="title is-5">
      </p>
      <p class="subtitle is-5">
          <!-- format the image -->
      </p>
      <p class="title is-3 mt-6 pt-6">
      <!-- <span class="pb-10">
          We're trusted by 5000+ business over the world
      </span> -->
      </p>
    </div>
    </div>
    </section>
    </div>
    </div>
    </div>  
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import LoginSignUpSidePage from '@/components/LoginSignUpSidePage.vue'
import * as firebaseui from 'firebaseui'
import "firebaseui/dist/firebaseui.css";

export default {
  name: "SignUp",
  data() {
    return {
      mode: this.$route.path,
      user: null,
      email: null,
      password: null,
      error: null
    }
  },
  components: {
    LoginSignUpSidePage
  },
  mounted() {
        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(this.$firebase.auth());
        }
        var uiConfig = {
            signInFlow: 'redirect',
            signInSuccessUrl: "/onboarding",
            signInOptions: [
              "google.com", //auth.GoogleAuthProvider.PROVIDER_ID,
              "password", // auth.EmailAuthProvider.PROVIDER_ID
            ],
            callbacks: {
              signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                // User successfully signed in.
                // Return type determines whether we continue the redirect automatically
                // or whether we leave that to developer to handle.
                var user = authResult.user;
                var url = 'https://app.metatext.ai/'
                var env = process.env.VUE_APP_ENV_NAME
                if(env != 'prod'){
                    url = 'https://dev-app.metatext.ai/'
                }
                const actionCodeSettings = {
                    url: url,
                    handleCodeInApp: false
                }
                if (authResult.additionalUserInfo.isNewUser)
                {   
                    user.sendEmailVerification(actionCodeSettings)
                }
                return true;
              },
              signInFailure: function(error) {
                Sentry.captureException(error);
              },
              uiShown: function() {
                // The widget is rendered.
                // Hide the loader.
                document.getElementById('loader').style.display = 'none';
              }
            },
        };
        ui.start("#firebaseui-auth-container", uiConfig);
  },
};
</script>

<style lang="scss" scoped>

#myVideo {
  position: fixed;
  left: -10em;
  top: -10em;
  min-width: 150%;
  min-height: 100%;
  object-fit: cover;
}
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
      
    }
  }
}
</style>